import { render, staticRenderFns } from "./recruitmentDetails.vue?vue&type=template&id=946b92e8&scoped=true&"
import script from "./recruitmentDetails.vue?vue&type=script&lang=js&"
export * from "./recruitmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./recruitmentDetails.vue?vue&type=style&index=0&id=946b92e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946b92e8",
  null
  
)

export default component.exports